import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  unauthorizedWinnerInfo: {
    msisdn: null,
    prizeId: null,
    name: null,
    existPrize: false,
    gameType: null,
    imageWonUrl: null,
    code: null,
  },
  isGamePage: null,
  playersDetails: {
    levelUp: false,
    postgamePointsFromCorrectAnswers: 0,
    postgamePointsFromRoundsWon: 0,
    postgamePointsTotal: 0,
    levelUpPoints: 0,
    currentLevel: 0,
    gamesToNextLevel: 0,
    currentLevelGamesWon: 0,
    levelUpGames: 0,
    lostDTOs: [],
    winDTO: {},
  },
  shuffledCardDTOS: null,
  gameType: null,
  attemptsUsed: null,
  gameCardDTOS: [],
  gameStateEnumForResumeGame: null,
  transitionOnlyForSearchingToOpponent: false,
  gameInProgress: false,
  gameID: null,
  gameFinished: false,
  gameWinnerMSISDN: '',
  gameWinnerUsername: '',
  registrationPoints: {},
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};




// WEBPACK FOOTER //
// ./src/store/modules/game/index.js